import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { AdminQueryKeys, getTechHealthMetrics, type TechHealthMetricsResponse } from '../api';

export function useTechHealthMetrics(): UseQueryResult<TechHealthMetricsResponse> {
  return useQuery({
    queryKey: AdminQueryKeys.techHealth(),
    queryFn: ({ signal }) => getTechHealthMetrics(signal),
    // Queue depth changes faster than billing/operational; refresh more often.
    staleTime: 30_000,
  });
}
